import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import * as modules from '../../store/decorator'

Vue.use(VueAxios, axios)

// Request interceptor to add session headers
axios.interceptors.request.use(
    (config) => {
        // Add session ID to requests if available
        const sessionDetail = modules.user.sessionDetail
        if (sessionDetail && sessionDetail.sessionId) {
            config.headers['X-RM-SessionId'] = sessionDetail.sessionId
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

// Response interceptor to handle 401 errors
axios.interceptors.response.use(
    (response) => {
        return response
    },
    async (error) => {
        const originalRequest = error.config

        // If we get a 401 and haven't already tried to refresh
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true

            try {
                // Try to refresh the session using the configured refresh endpoint
                const sessionDetail = modules.user.sessionDetail
                
                if (sessionDetail && sessionDetail.sessionId) {
                    // Use the refresh endpoint that's already configured
                    const refreshResponse = await axios.put(
                        `${process.env.VUE_APP_DOT_NET_API_BASE_URL}${process.env.VUE_APP_DOT_NET_API_REFRESH}`,
                        {},
                        {
                            headers: {
                                'X-RM-SessionId': sessionDetail.sessionId
                            }
                        }
                    )

                    if (refreshResponse.status === 200) {
                        // Session refreshed successfully, retry the original request
                        return axios(originalRequest)
                    }
                }
            } catch (refreshError) {
                // If refresh fails, check if user is still authenticated
                if (Vue.prototype.$auth && Vue.prototype.$auth.check()) {
                    // Try to logout gracefully
                    Vue.prototype.$auth.logout({
                        redirect: { name: 'login' }
                    })
                }
                return Promise.reject(refreshError)
            }
        }

        // For other 401 errors or if refresh failed, handle gracefully
        if (error.response && error.response.status === 401) {
            // Only logout if we're not already on the login page
            if (Vue.prototype.$auth && Vue.prototype.$auth.check()) {
                Vue.prototype.$auth.logout({
                    redirect: { name: 'login' }
                })
            }
        }

        return Promise.reject(error)
    }
)

// Vue.axios.defaults.headers.common['X-RM-SessionId'] =
// Vue.axios.defaults.headers.common['X-RM-IP'] =
// Vue.axios.defaults.headers.common['X-RM-UserAgent'] = 
// Vue.axios.defaults.headers.common['X-RM-Channel'] = 'offline'